(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    (() => {
 const selector = 'details.facets__disclosure.js-filter';
 document.addEventListener('click', event => {
  const summary = event.target.closest('summary');
  const chosen = summary?.parentElement;
  document.querySelectorAll(selector + '[open]').forEach(panel => {
   if (panel !== chosen && !panel.contains(event.target)) panel.open = false;
  });
 });
 document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll(selector + '[open]').forEach(panel => {panel.open = false;panel.querySelector('summary').focus();});
 });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
 const initialize = () => {
  document.querySelectorAll('.wtd-nav:not([data-ready])').forEach(nav => {
   nav.dataset.ready = 'true';
   const disclosures = [...nav.querySelectorAll('.wtd-disclosure')];
   const closeOthers = current => disclosures.forEach(item => { if (item !== current) item.open = false; });
   disclosures.forEach(details => {
    const summary = details.querySelector('summary');
    let timer;
    summary.addEventListener('pointerenter', event => {
     if (event.pointerType !== 'mouse') return;
     clearTimeout(timer); closeOthers(details); details.open = true;
    });
    details.addEventListener('pointerenter', () => clearTimeout(timer));
    details.addEventListener('pointerleave', event => {
     if (event.pointerType === 'mouse') timer = setTimeout(() => {
      if (!details.contains(document.activeElement)) details.open = false;
     }, 180);
    });
    details.addEventListener('toggle', () => { summary.setAttribute('aria-expanded', String(details.open)); if (details.open) closeOthers(details); });
    summary.setAttribute('aria-expanded', String(details.open));
    details.addEventListener('keydown', event => {
     if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); details.open = false; summary.focus(); }
    });
    details.addEventListener('focusout', () => setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 0));
    const categoryLinks = [...details.querySelectorAll('[data-radio-category]')];
    const activateCategory = link => categoryLinks.forEach(item => {
      const selected = item === link;
      item.dataset.selected = String(selected);
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    categoryLinks.forEach(link => {
      link.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && !details.querySelector('[data-radio-panel]:focus-within')) activateCategory(link);
      });
      link.addEventListener('focus', () => activateCategory(link));
    });
    details.querySelectorAll('[role=tablist]').forEach(list => {
     const tabs = [...list.querySelectorAll('[role=tab]')];
     const activate = tab => tabs.forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
     });
     tabs.forEach((tab,index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && !details.querySelector('[role=tabpanel]:focus-within')) activate(tab); });
      tab.addEventListener('keydown', event => {
       let next;
       if(event.key === 'ArrowDown') next = (index + 1) % tabs.length;
       if(event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
       if(event.key === 'Home') next = 0;
       if(event.key === 'End') next = tabs.length - 1;
       if(next !== undefined) { event.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
      });
     });
    });
   });
   document.addEventListener('pointerdown', event => { if(!nav.contains(event.target)) closeOthers(null); });
  });
 };
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
 document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-1700hdvk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nx1700hdvk-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nx1700hdvk-redesign]');
    const price = panel && panel.querySelector('.nx1700hdvk-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nx1700hdvk-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-1800hduk2-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nx1800hduk2-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nx1800hduk2-redesign]');
    const price = panel && panel.querySelector('.nx1800hduk2-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nx1800hduk2-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-p1200avk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nxp1200av-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nxp1200av-redesign]');
    const price = panel && panel.querySelector('.nxp1200av-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nxp1200av-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-p1200isnvk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nxp1200isnv-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nxp1200isnv-redesign]');
    const price = panel && panel.querySelector('.nxp1200isnv-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nxp1200isnv-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-p1200nvk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nxp1200nv-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nxp1200nv-redesign]');
    const price = panel && panel.querySelector('.nxp1200nv-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nxp1200nv-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-p1202avk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nxp1202-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nxp1202-redesign]');
    const price = panel && panel.querySelector('.nxp1202-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nxp1202-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-p1300auk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nxp1300-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nxp1300-redesign]');
    const price = panel && panel.querySelector('.nxp1300-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nxp1300-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-p1300isnuk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nxp1300isnu-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nxp1300isnu-redesign]');
    const price = panel && panel.querySelector('.nxp1300isnu-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nxp1300isnu-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-p1300nuk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nxp1300nu-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nxp1300nu-redesign]');
    const price = panel && panel.querySelector('.nxp1300nu-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nxp1300nu-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-p1302auk-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#nxp1302-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-nxp1302-redesign]');
    const price = panel && panel.querySelector('.nxp1302-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-nxp1302-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pkt-300-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
      if (!event.target.matches('#pkt300-variant-select')) return;
      const option = event.target.options[event.target.selectedIndex];
      const panel = event.target.closest('[data-pkt300-redesign]');
      const price = panel && panel.querySelector('.pkt300-redesign__price');
      if (price && option) price.textContent = option.dataset.price;
    });

    document.addEventListener('click', function(event) {
      const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
      if (!button) return;
      const panel = button.closest('[data-pkt300-redesign]');
      const input = panel && panel.querySelector('input[name="quantity"]');
      if (!input) return;
      const current = Number(input.value) || 1;
      input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pkt-multipack-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
      if (!event.target.matches('#pktpacks-variant-select')) return;
      const option = event.target.options[event.target.selectedIndex];
      const panel = event.target.closest('[data-pktpacks-redesign]');
      const price = panel && panel.querySelector('.pktpacks-redesign__price');
      if (price && option) price.textContent = option.dataset.price;
    });

    document.addEventListener('click', function(event) {
      const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
      if (!button) return;
      const panel = button.closest('[data-pktpacks-redesign]');
      const input = panel && panel.querySelector('input[name="quantity"]');
      if (!input) return;
      const current = Number(input.value) || 1;
      input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtd-accessory-redesign"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('#wtdacc-variant-select')) return;
    const option = event.target.options[event.target.selectedIndex];
    const panel = event.target.closest('[data-wtdacc-redesign]');
    const price = panel && panel.querySelector('.wtdacc-redesign__price');
    if (price && option) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const panel = button.closest('[data-wtdacc-redesign]');
    const input = panel && panel.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number(input.value) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtd-radio-quiz"] && !Shopify.designMode) return;
  try {
    function wtdQuizNext(a) {
  if (!a.safety) return 'safety';
  if (a.safety !== 'no') return 'result';
  if (!a.goal) return 'goal';
  if (a.goal === 'existing') {
    if (!a.model) return 'model';
    if (a.model === 'other') return 'result';
    return a.quantity ? 'result' : 'quantity';
  }
  if (!a.format) return 'format';
  if (a.format === 'handheld' && !a.space) return 'space';
  if (!a.band) return 'band';
  if (a.format !== 'handheld' && a.band === 'help') return 'result';
  if (!a.mode) return 'mode';
  if (a.mode === 'help' || (a.format === 'handheld' && a.mode === 'dmr') || (a.format !== 'handheld' && a.mode === 'nxdn')) return 'result';
  return a.quantity ? 'result' : 'quantity';
}
function wtdQuizMatch(a) {
  const result = (kind,handles = []) => ({kind,handles});
  if (wtdQuizNext(a) !== 'result') return result('missing');
  if (a.safety === 'yes') return result('safety');
  if (a.safety !== 'no') return result('safety_unknown');
  const exact = ['pkt-300k','nx-p1300auk','nx-p1200avk','nx-p1300nuk','nx-p1200nvk','nx-1700hdvk','nx-1800hduk2'];
  if (a.goal === 'existing') return exact.includes(a.model) ? result('existing',[a.model]) : result('compatibility');
  if (a.format !== 'handheld' && a.band === 'help') return result('band');
  if (a.mode === 'help' || (a.format === 'handheld' && a.mode === 'dmr') || (a.format !== 'handheld' && a.mode === 'nxdn')) return result('mode');
  if (a.format !== 'handheld') return result('mobile',[a.band === 'vhf' ? 'nx-1700hdvk' : 'nx-1800hduk2']);
  if (a.mode === 'nxdn') return result('digital',a.band === 'help' ? ['nx-p1300nuk','nx-p1200nvk'] : [a.band === 'vhf' ? 'nx-p1200nvk' : 'nx-p1300nuk']);
  if (a.space === 'small' && a.band !== 'vhf') return result('compact',['pkt-300k']);
  return result('analog',a.band === 'help' ? ['nx-p1300auk','nx-p1200avk'] : [a.band === 'vhf' ? 'nx-p1200avk' : 'nx-p1300auk']);
}
function wtdQuizPack(handle,quantity) {
  const packs = {
    'pkt-300k':{'2':'2-pack-kenwood-pkt-300','4':'4-pack-kenwood-pkt-300','6':'pkt-300bkp6-6-pack-with-single-chargers'},
    'nx-p1300auk':{'2':'2-pack-kenwood-nx-p1300au-5-watt-analog-uhf','4':'4-pack-nx-p1300au-5-watt-analog-uhf-kenwood','6':'6-pack-nx-p1300auk-protalk-business-radio-5w-analog-uhf-kenwood'}
  };
  return packs[handle]?.[quantity] || null;
}
(() => {
  const publish = (name,data = {}) => {
    try { if (window.Shopify?.analytics?.publish) Promise.resolve(window.Shopify.analytics.publish(`wtd:${name}`,data)).catch(() => {}); } catch {}
  };
  let reportedResult = false;
  const dialog = document.getElementById('wtd-radio-quiz');
  const templates = document.getElementById('wtd-quiz-templates');
  if (!dialog || !templates || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const strings = JSON.parse(templates.querySelector('[data-quiz-strings]').textContent);
  const body = dialog.querySelector('[data-quiz-body]');
  const next = dialog.querySelector('[data-quiz-next]');
  const back = dialog.querySelector('[data-quiz-back]');
  const restart = dialog.querySelector('[data-quiz-restart]');
  let history = [];
  let answers = {};
  let step = 'safety';
  let opener;
  let previousOverflow = '';
  const text = (selector,value) => {const el = body.querySelector(selector);if (el) el.textContent = value;};
  const clone = selector => templates.querySelector(selector)?.content.cloneNode(true);
  function answerSummary() {
    return history.map(({key,value}) => {
      const template = templates.querySelector(`[data-quiz-question="${key}"]`).content;
      const label = template.querySelector(`input[value="${value}"]`).closest('label').querySelector('strong').textContent;
      return `${template.querySelector('h2').textContent}\n${label}`;
    }).join('\n\n');
  }
  function render() {
    step = wtdQuizNext(answers);
    body.replaceChildren();
    dialog.querySelector('[data-quiz-progress-text]').textContent = step === 'result' ? dialog.querySelector('[data-quiz-progress-text]').dataset.progressDone : dialog.querySelector('[data-quiz-progress-text]').dataset.progressLabel.replace('__NUMBER__', history.length + 1);
    next.hidden = step === 'result';
    back.hidden = !history.length;
    restart.hidden = !history.length;
    dialog.querySelector('.wtd-quiz__progress span').style.width = `${step === 'result' ? 100 : Math.min(90,history.length * 14)}%`;
    if (step !== 'result') {
      body.append(clone(`[data-quiz-question="${step}"]`));
      next.disabled = true;
      next.textContent = strings.continue;
    } else {
      body.append(clone('[data-quiz-result]'));
      if (!reportedResult) {publish('quiz_completed');reportedResult = true;}
      const match = wtdQuizMatch(answers);
      const cards = body.querySelector('[data-result-cards]');
      const handles = [...match.handles];
      if (handles.length === 1) {
        const pack = wtdQuizPack(handles[0],answers.quantity);
        if (pack && templates.querySelector(`[data-quiz-product="${pack}"]`)) handles.unshift(pack);
      }
      handles.forEach(handle => {
        const card = clone(`[data-quiz-product="${handle}"]`);
        if (card) {
          if (!match.handles.includes(handle)) card.querySelector('a').textContent = strings.pack;
          cards.append(card);
        }
      });
      const kind = match.handles.length && !cards.children.length ? 'missing' : match.kind;
      text('h2',strings[`${kind}_title`] || strings.result_title);
      text('[data-result-intro]',strings[`${kind}_body`] || strings.result_body);
      const checks = [];
      if (cards.children.length) {
        checks.push(answers.goal === 'existing' ? strings.existing_check : strings.new_check);
        if (kind === 'mobile' || ['nx-1700hdvk','nx-1800hduk2'].includes(answers.model)) checks.push(strings.mobile_check);
        else checks.push(strings.coverage);
        if (answers.band === 'help') checks.push(strings.band_check);
      }
      body.querySelector('.wtd-quiz__note').hidden = !checks.length;
      text('[data-result-check]',checks.join(' '));
      body.querySelector('[data-result-team]').hidden = !answers.quantity || answers.quantity === '1';
      const browse = body.querySelector('[data-result-browse]');
      const group = ['safety','safety_unknown'].includes(kind) ? 'safe' : ['mobile','band'].includes(kind) ? 'mobile' : ['analog','digital','mode'].includes(kind) ? 'handheld' : 'all';
      const paths = {safe:'intrinsically-safe-series',mobile:'land-mobile-series',handheld:'protalk-nx-p1000-series',all:'radios'};
      browse.href = `/collections/${paths[group]}`;
      browse.textContent = strings[`browse_${group}`];
      text('[data-result-answers]',answerSummary());
    }
    dialog.scrollTop = 0;
    body.querySelector('h2').focus({preventScroll:true});
  }
  function reset() {history = [];answers = {};reportedResult = false;render();}
  function open(trigger) {
    opener = trigger || document.activeElement;
    if (!dialog.open) {previousOverflow = document.body.style.overflow;document.body.style.overflow = 'hidden';dialog.showModal();}
    reset();
    publish('quiz_started');
  }
  function close() {dialog.close();}
  document.addEventListener('click',event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor) return;
    let url;
    try {url = new URL(anchor.href,location.href);} catch {return;}
    if (url.origin === location.origin && url.hash === '#quiz') {
      event.preventDefault();event.stopImmediatePropagation();open(anchor);
    }
  },true);
  dialog.addEventListener('change',event => {
    if (event.target.matches('input[name="quiz-answer"]')) {
      next.disabled = false;
      next.textContent = wtdQuizNext({...answers,[step]:event.target.value}) === 'result' ? strings.results : strings.continue;
    }
  });
  next.addEventListener('click',() => {
    const selected = body.querySelector('input[name="quiz-answer"]:checked');
    if (!selected) return;
    history.push({key:step,value:selected.value});
    answers[step] = selected.value;
    render();
  });
  back.addEventListener('click',() => {
    const previous = history.pop();
    answers = Object.fromEntries(history.map(({key,value}) => [key,value]));
    render();
    if (previous) {
      const option = body.querySelector(`input[value="${previous.value}"]`);
      if (option) {option.checked = true;next.disabled = false;next.textContent = wtdQuizNext({...answers,[step]:previous.value}) === 'result' ? strings.results : strings.continue;}
    }
  });
  restart.addEventListener('click',reset);
  dialog.querySelector('[data-quiz-close]').addEventListener('click',close);
  dialog.addEventListener('close',() => {document.body.style.overflow = previousOverflow;opener?.focus({preventScroll:true});});
  body.addEventListener('click',async event => {
    const link = event.target.closest('a[href]');
    if (link) {
      const target = new URL(link.href,location.href);
      if (target.origin === location.origin && target.pathname.startsWith('/products/')) publish('quiz_product_clicked',{product_handle:target.pathname.split('/').pop()});
      if (target.origin === location.origin && target.pathname === '/pages/contact') publish('quiz_quote_clicked');
    }
    if (!event.target.closest('[data-quiz-copy]')) return;
    try {await navigator.clipboard.writeText(answerSummary());text('[data-copy-status]',strings.copied);}
    catch {text('[data-copy-status]',strings.copy_failed);}
  });
  if (location.hash === '#quiz') open();
})();
  } catch(e) { console.error(e); }
})();

})();
